import { useFiltersContext } from '@/context'
import reservationQueries from '@/graphql/queries/reservation.queries'
import { ReservationsFilterParams, ReservationsListRow } from '@/types/Reservation'
import { formatDate } from '@/util'
import { getReservationFilterParams } from '@/util/FiltersUtil'

import { useGraphql } from '../useGraphql'

const useReservations = () => {
  const [
    { marketSegmentFilter, reservationsFilters, reservationMinLengthOfStay, reservationMoveOutRange, searchString },
  ] = useFiltersContext()
  const { moveOutDate, moveOutMax } = reservationMoveOutRange

  const filterParams: Partial<ReservationsFilterParams> = {
    ...getReservationFilterParams(reservationsFilters),
    marketSegmentIds: marketSegmentFilter.marketSegmentIds,
    moveOutMax: moveOutMax ? formatDate(moveOutMax, 'yyyy-MM-dd') : undefined,
    moveOutDate: moveOutDate ? formatDate(moveOutDate, 'yyyy-MM-dd') : undefined,
    lengthOfStayMin: reservationMinLengthOfStay,
  }

  const sortBy = filterParams.moveInDate?.length
    ? { field: 'MoveInDate', direction: 'Ascending' }
    : filterParams.moveOutDate?.length
      ? { field: 'MoveOutDate', direction: 'Ascending' }
      : null

  const reservationsQuery = useGraphql<{ reservations: ReservationsListRow[] }>(
    'reservations',
    reservationQueries.getReservationsList,
    {
      filter: filterParams,
      searchString: searchString,
      sortBy: sortBy,
    },
  )
  return reservationsQuery
}

export default useReservations
